import { createFileRoute, Outlet } from '@tanstack/react-router';

import { i18n } from '../../i18n';

export const Route = createFileRoute('/workforce')({
  staticData: {
    permissionSection: 'planner',
    breadcrumb: () => i18n.t('terms.workforce', { ns: 'common' }),
  },
  component: Outlet,
});
